import { render } from "./CustomColor.vue?vue&type=template&id=743fa66b"
import script from "./CustomColor.vue?vue&type=script&lang=js"
export * from "./CustomColor.vue?vue&type=script&lang=js"
script.render = render

export default script